// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JQlc","type":"styles_type__2fLIj","choices":"styles_choices__1Wvzh"};